import ContentItemWithResolver from "models/ContentItemWithResolver";
import get from 'lodash/get';

export default class SliderButtonSection extends ContentItemWithResolver {

  get sliderButtons() {
    return get(this, '_buttons', []);
  }
}
